<template>
  <div>
    <el-card v-loading="isLoading">
      <el-page-header content="Договор" @back="goBack">
      </el-page-header>
      <el-divider></el-divider>
      <el-button native-type="submit" type="basic" @click="signDocument()" v-if="!isDocumentSigned && currentBase64 && canSign">
        Подписать
        <i class="el-icon-check" style="font-weight: bold"/>
      </el-button>
      <el-button native-type="submit" type="basic" @click="downloadOriginalFile()">
        Скачать оригинальный файл
        <i class="el-icon-download" style="font-weight: bold"/>
      </el-button>
      <el-button native-type="submit" type="basic" @click="downloadSign()" v-if="isDocumentSigned && currentCms">
        Скачать подпись
        <i class="el-icon-download" style="font-weight: bold"/>
      </el-button>
      <br>
      <div style="margin-top: 20px; font-size: 12px">
        Подписано {{ cmsCount }} из {{ signersAmount }}
      </div>
      <el-divider></el-divider>
      <el-tabs v-model="activeName" class="is-flex is-justify-center" @tab-click="handleClick">
        <el-tab-pane label="История" name="1">
          <div class="history-table">
            <el-table
                :data="documentHistory"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                style="width: 100%; cursor: pointer">
              <el-table-column
                  prop="meta.documentId"
                  label="Id документа">
              </el-table-column>
              <el-table-column
                  label="Номер документа">
                <template slot-scope="scope">
                  {{ scope.row.data.body ? scope.row.data.body.documentWorkplaceRailcar.documentRailcar.docNumber : '' }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="meta.sendedAt"
                  label="Дата отправления">
              </el-table-column>
              <el-table-column
                  prop="createdAt"
                  label="Дата cоздания">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Подписи" name="2">
          <el-card v-if="signData.length > 0" style="margin-top: 30px;">
            <h3>Информация об электронном документе</h3>
            <div class="sign-table">
              <table v-for="item in signData" :key="item.certificate" style="margin-bottom: 30px;">
                <tr>
                  <td>Результат проверки сертификата</td>
                  <td>{{ item.result }}</td>
                </tr>
                <tr>
                  <td>ИИН</td>
                  <td>{{ item.iin }}</td>
                </tr>
                <tr>
                  <td>Издатель</td>
                  <td>{{ item.issuer_name }}</td>
                </tr>
                <tr>
                  <td>ФИО</td>
                  <td>{{ item.name + ' ' + item.father_name }}</td>
                </tr>
                <tr>
                  <td>Серийный номер сертификата</td>
                  <td>{{ item.certificate }}</td>
                </tr>
                <tr>
                  <td>Срок действия сертификата</td>
                  <td>{{ item.time_from + ' - ' + item.until }}</td>
                </tr>
                <tr v-if="item.organization">
                  <td>Организация</td>
                  <td>{{ item.organization }}</td>
                </tr>
                <tr v-if="item.organization_bin">
                  <td>БИН организаций</td>
                  <td>{{ item.organization_bin }}</td>
                </tr>
              </table>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="Статусы" name="3">
          <div class="history-table">
            <el-table
                :data="statuses"
                :row-class-name="tableRowClassName"
                style="width: 100%; cursor: pointer">
              <el-table-column
                  prop="statusName"
                  label="Статус">
              </el-table-column>
              <el-table-column
                  prop="createdAt"
                  label="Дата">
                <template slot-scope="scope">
                  {{ scope.row.createdAt ? getFormattedDate(scope.row.createdAt) : '' }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="comment"
                  label="Комментарий">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div style="margin-top: 20px;"></div>
      <el-button v-if="activeName !== '3'" native-type="submit" type="basic" @click="stepHandle((parseInt(activeName) + 1).toString())">
        Далее
        <i class="el-icon-arrow-right" style="font-weight: bold"/>
      </el-button>
      <el-button v-if="activeName !== '1'" native-type="submit" type="basic" @click="stepHandle((parseInt(activeName) - 1).toString())">
        <i class="el-icon-arrow-left" style="font-weight: bold"/>
        Назад
      </el-button>
    </el-card>
    <el-dialog :title="currentHistoryItem.hash" :visible.sync="historyDialog">
      <pre>{{ currentHistoryItem.meta }}</pre>
      <br>
      <div>{{ currentHistoryItem.data }}</div>
    </el-dialog>
  </div>
</template>

<script>
import blockchainApi from '@/modules/api/blockchain'
import { MAIN_API } from '@/modules/api/apiUrl'
import { NCALayerClient } from 'ncalayer-js-client'
import signApi from '@/modules/api/sign'
import { format, parse } from 'date-fns'
import authorizationAPI from '@/modules/api/authorization'

export default {
  name: 'AgreementDetail',
  data () {
    return {
      signData: [],
      statusDialog: false,
      isLoading: false,
      documentInfo: {},
      statusForm: {
        status: '',
        comment: ''
      },
      statuses: [],
      activeName: '1',
      documentId: '',
      docType: '',
      canDownloadSign: false,
      documentHistory: [],
      historyDialog: false,
      currentHistoryItem: {},
      currentBase64: '',
      currentBase64Item: {},
      cmsCount: 0,
      currentCmsItem: {},
      signersAmount: 2,
      currentCms: ''
    }
  },
  mounted () {
    this.getDocumentByHash()
    this.getFilteredHistory()
  },
  computed: {
    getHash () {
      return this.$route.query.hash
    },
    isDocumentSigned () {
      return this.cmsCount === this.signersAmount
    },
    isRolePetroleum () {
      return authorizationAPI.isRolePetroleum()
    },
    canSign () {
      if (this.isRolePetroleum) {
        return this.cmsCount === 0
      } else {
        return this.cmsCount !== 0
      }
    }
  },
  watch: {
  },
  methods: {
    getDocumentByHash () {
      this.isLoading = true
      blockchainApi.getDocumentByHash(this.getHash).then((resp) => {
        this.documentInfo = resp.data
        this.documentId = this.documentInfo.meta.documentId
        this.getStatuses()
      }).finally(() => {
        this.isLoading = false
      })
    },
    getFilteredHistory () {
      blockchainApi.filterDocument(this.getHash)
        .then(resp => {
          if (resp && resp.length > 0) {
            let isMultiple = false
            let cmsCounter1 = 0
            this.documentHistory = resp.map((item, index) => {
              if (item.meta.total > 1) {
                isMultiple = true
              }
              if (this.isJson(item.data)) {
                // item.data = JSON.stringify(JSON.parse(item.data), null, 2)
                item.data = JSON.parse(item.data)
              } else {
                if (item.meta.extension.includes('pdf')) {
                  this.currentBase64Item = item
                  this.currentBase64 = item.data
                } else if (item.meta.extension.includes('cms')) {
                  this.currentCmsItem = item
                  this.currentCms = item.data
                  if (!isMultiple) {
                    cmsCounter1++
                  }
                }
              }
              return item
            })
            this.cmsCount = cmsCounter1
            if (isMultiple) {
              const pdf = resp.filter(item => item.meta.extension.includes('pdf'))
              pdf.sort((a, b) => a.meta.part - b.meta.part)
              this.currentBase64 = pdf.map(item => item.data).join('')
              let totalCms = 0
              let cmsCounter = 0
              resp.forEach((item) => {
                if (item.meta.extension.includes('cms')) {
                  totalCms = item.meta.total
                  cmsCounter++
                }
              })
              if (totalCms) {
                if (cmsCounter > totalCms) {
                  this.cmsCount = 2
                } else if (cmsCounter === totalCms) {
                  this.cmsCount = 1
                }
                const block = resp.slice(-totalCms)
                block.sort((a, b) => a.meta.part - b.meta.part)
                this.currentCms = block.map(p => p.data).join('')
              }
            }
            // const blob = this.base64ToBlob(this.currentCms)
            // this.submitUpload(blob)
            this.getSign()
          }
        })
    },
    base64ToBlob (base64, mimeType = 'application/pkcs7-signature') {
      const cleanBase64 = base64.includes(',') ? base64.split(',')[1] : base64
      const byteCharacters = atob(cleanBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: mimeType })
    },
    getStatuses () {
      const data = {
        hash: this.documentInfo.idHash
      }
      blockchainApi.getStatus(data).then((resp) => {
        const statuses = resp.map(item => {
          if (item.status === 'CREATED') {
            item.statusName = 'Создан'
          } else if (item.status === 'SENDED') {
            item.statusName = 'Отправлен'
          } else if (item.status === 'APPROVED') {
            item.statusName = 'Утвержден'
          } else if (item.status === 'RECEIVED') {
            item.statusName = 'Доставлен'
          } else if (item.status === 'REJECTED') {
            item.statusName = 'Отклонен'
          } else if (item.status === 'CANCELED') {
            item.statusName = 'Отменен'
          } else if (item.status === 'UPDATED') {
            item.statusName = 'Отредактирован'
          } else if (item.status === 'CONFIRMED') {
            item.statusName = 'Подтвержден'
          } else if (item.status === 'SIGNED') {
            item.statusName = 'Подписан'
          }
          return item
        })
        statuses.forEach(item => {
          if (this.statuses.filter(i => i.status === item.status).length === 0) {
            this.statuses.push(item)
          }
        })
      }).catch(err => {
        console.log('err', err)
      })
    },
    downloadOriginalFile () {
      this.downloadBase64Pdf(this.currentBase64, this.documentId + '.pdf')
    },
    downloadSign () {
      this.downloadBase64Pdf(this.currentCms, this.documentId + '.pdf.cms')
    },
    downloadBase64Pdf (base64String, fileName) {
      const byteCharacters = atob(base64String)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    getSign () {
      fetch(MAIN_API + '/api/agreements/download/signed/' + this.documentId)
        .then(resp => {
          return resp.blob()
        }).then(blob => {
          this.submitUpload(blob)
        })
    },
    submitUpload (file) {
      const data = new FormData()
      data.append('file', file, 'file')
      signApi.checkSign(data).then((resp) => {
        this.signData = JSON.parse(resp.body).map(item => {
          const dateFormat = 'dd.MM.yyyy HH:mm:ss'
          item.time_from = item.time_from.split(' ').slice(0, -1).join(' ')
          item.until = item.until.split(' ').slice(0, -1).join(' ')
          item.time_from_date = parse(item.time_from, dateFormat, new Date())
          item.until_date = parse(item.until, dateFormat, new Date())
          item.result = item.until_date > new Date() ? 'Успешно' : 'Срок действия сертификата истек'
          return item
        })
      }).catch(err => {
        console.log(err)
      })
      // this.$refs.upload.submit()
    },
    signDocument () {
      const ncalayerClient = new NCALayerClient()
      const base64 = this.currentCms ? this.currentCms : this.currentBase64
      console.log(this.currentBase64)
      ncalayerClient.connect().then(async () => {
        const signatureResult = await ncalayerClient.createCMSSignatureFromBase64('PKCS12', base64, 'SIGNATURE', true)
        console.log(signatureResult)
        const data = {
          uuid: this.documentId,
          base64: signatureResult
        }
        signApi.saveSignAgreement(data).then(async resp => {
          alert('Документ успешно подписан!')
          this.getDocumentByHash()
          this.getFilteredHistory()
        }).catch(err => {
          alert('Не удалось подписать документ ', err)
        })
      }).catch(err => {
        console.log(err)
        alert('Запустите ncaLayer', err)
      })
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.split(',')[1])
        reader.onerror = (error) => reject(error)
      })
    },
    stepHandle (val) {
      this.activeName = val
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    goBack () {
      this.$router.go(-1)
    },
    isJson (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    getFormattedDate (str) {
      const x = new Date()
      let date = ''
      if (str) {
        try {
          const attributeValueDate = new Date(str)
          const utc = attributeValueDate.getTime() + (x.getTimezoneOffset() * 60000)
          const nd = new Date(utc + (3600000 * 5))
          date = format(nd, 'dd.MM.yyyy HH:mm')
        } catch (e) {
          date = str
        }
      }
      return date
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'success-row'
      }
      return ''
    },
    rowClick (val) {
      this.currentHistoryItem = val
      this.historyDialog = true
    }
  }
}
</script>

<style>

.el-table .success-row {
  background-color: #f0f9eb !important;
}
.sign-table table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

/*.sign-table td, th {*/
/*  border: 1px solid #dddddd;*/
/*  text-align: left;*/
/*  padding: 8px;*/
/*}*/

.sign-table tr:nth-child(even) {
  background-color: #f3f3f3;
}

</style>
